import config from '@/config'

export default {
	id: 'SIMPLE_PAYWALL_4W_29_99_4W_29_99',
	providers: {
		stripe: config('stripe_cheap_and_short'),
		braintree: 'pro_short_cheap',
		paltaMap: {
			USD: 'simple_premium_v2_4w_29_99_4w_29_99_usd',
			ARS: 'simple_premium_4w_39990_4w_39990_ars',
			COP: 'simple_premium_4w_119990_4w_119990_cop',
			CLP: 'simple_premium_4w_29990_4w_29990_clp',
		},
		primer: 'prd_rBTU873XJMb4',
	},
	model: {
		commitment_period: 0,
		intro_period_value: 4,
		intro_period_type: 'week',
		next_period_value: 4,
		next_period_type: 'week',
	},
	trial: {
		days: 28,
		priceMap: {
			USD: 29.99,
			EUR: 29.99,
			GBP: 29.99,
			AUD: 49.99,
			CAD: 49.99,
			DKK: 259,
			SEK: 399,
			NOK: 399,
			BRL: 199.99,
			MXN: 499,
			TRY: 999,
			ARS: 39990,
			COP: 119990,
			CLP: 29990,
		},
	},
	subscription: {
		interval: 'month',
		intervalCount: 1,
		priceMap: {
			USD: 29.99,
			EUR: 29.99,
			GBP: 29.99,
			AUD: 49.99,
			CAD: 49.99,
			DKK: 259,
			SEK: 399,
			NOK: 399,
			BRL: 199.99,
			MXN: 499,
			TRY: 999,
			ARS: 39990,
			COP: 119990,
			CLP: 29990,
		},
	},
	options: ($t, product, $tc) => ({
		explicitTermsPeriodText: $t('pages.program.organic.cheap_and_short.plans.30_days.into_period_text'), // 'first month'
		explicitTermsIntervalText: $t('pages.program.organic.cheap_and_short.plans.30_days.sub_period_text'), // 'monthly'
		billingSubtitlePeriodText: $tc('common.duration.week.first', 4), // 'first 4 weeks'
		footerPeriodText: $tc('common.duration.week.dashed.capitalized', 4), // '4-Week'
		footerIntervalText: $tc('common.duration.week.dashed.capitalized', 4), // '4-Week'
	}),
}
